import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject, throwError} from 'rxjs';
import {Game} from '../../domain/game';
import {catchError, retry} from 'rxjs/operators';

@Injectable()
export class GameManagementService {
  constructor(private httpClient: HttpClient) {
  }

  getGames(authorizationToken: string): Observable<Game[]> {
    return this.httpClient.get<Game[]>(`/api/spelgemma.php`, {
      headers: {
        Authorization: authorizationToken
      }
    }).pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}

